import Col from "antd/lib/col";
import "antd/lib/col/style/css";

export default Col;
